/**
 * Determines whether a user falls within the given traffic percentage rollout.
 * Eligible when the percentage threshold exceeds the modulus 100 of the identifier.
 *
 * Any stable numeric identifier can be used (e.g. user ID, petition ID) as long
 * as it does not change between sessions.
 *
 * Treatment is consistent: once a user becomes eligible at a given percentage,
 * they remain eligible for any higher percentage. However, treatment is not
 * persistent — it depends entirely on the currently configured traffic percentage.
 * If the percentage is lowered below a user's bucket, they lose eligibility.
 *
 * @example
 * // User 84729351 → bucket 51 (84729351 % 100)
 * isEligibleForTrafficPercentage(30, '84729351');  // false — 30 <= 51
 * isEligibleForTrafficPercentage(51, '84729351');  // false — 51 is not > 51
 * isEligibleForTrafficPercentage(52, '84729351');  // true  — 52 > 51
 * isEligibleForTrafficPercentage(80, '84729351');  // true  — still eligible at higher %
 */
export function isEligibleForTrafficPercentage(
	trafficPercentage: number | undefined | null,
	identifier: number | string,
): boolean {
	if (trafficPercentage == null) return false;
	return trafficPercentage > Number(identifier) % 100;
}
